export const SET_LOADING = 'SET_LOADING';
export const SET_LOADING_2 = 'SET_LOADING_2';

export const TRIP_CHANGE = 'TRIP_CHANGE';

export const UPDATE_PLACE = 'UPDATE_PLACE';
export const DELETE_PLACE = 'DELETE_PLACE';
export const INSERT_PLACE = 'INSERT_PLACE';

export const UPDATE_MONEY = 'UPDATE_MONEY';
export const DELETE_MONEY = 'DELETE_MONEY';
export const INSERT_MONEY = 'INSERT_MONEY';
